
<script>
import mapMixin from "./mixins/mapMixins";
export default {
  mixins: [mapMixin],
  props: {
    position: {
      type: Array,
      default() {
        return [];
      },
    },
    icon: {
      type: String,
      default: "",
    },
    imageSize: {
      type: Array,
      default() {
        return [20, 20];
      },
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  render() {
    return null;
  },
  methods: {
    handleMapReady(map) {
      let imageSize = this.imageSize;
      let width = imageSize[0] || 20;
      let height = imageSize[1] || 20;
      // eslint-disable-next-line no-undef
      const marker = (this.$amapComponent = new AMap.Marker({
        position: this.position || [],
        map: map,
        offset: [-width / 2, -height / 2],
      }));
      if (this.icon) {
        // eslint-disable-next-line no-undef
        let markerIcon = new AMap.Icon({
          image: this.icon,
          // eslint-disable-next-line no-undef
          // imageSize: new AMap.Size(20, 20),
          imageSize: imageSize,
        });
        this.$amapComponent.setIcon(markerIcon);
      }
      if (this.title) {
        // 设置鼠标划过点标记显示的文字提示
        marker.setTitle(this.title);
      }

      this.$amapComponent.on("click", () => {
        this.$emit("click");
      });
    },
  },
};
</script>

<style>
</style>